import React from "react";
import Breadcrumb from "../../../components/Breadcrumb";
import { SOCIETY_GATEKEEPER } from "../../../Routing/routes";
import GateKeeperListLayer from "./Component/GateKeeperListLayer";

const GateKeeperLogin = () => {
    const links = [{ to: SOCIETY_GATEKEEPER, text: 'Manage GateKeeper Login' }]
    return (
        <>
            <Breadcrumb replaceClass="mb-24" description='Configure and manage gatekeeper login credentials' links={links} headingTitle="Manage GateKeeper Login" />
            <GateKeeperListLayer />
        </>
    );
};

export default GateKeeperLogin;
